import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { oauthServiceSalesforce } from "../../utilities/partnerServices";
import { getResourceService,getResourceArticlesService } from "../../utilities/dashboardServices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
export const oauthApi = createAsyncThunk(
  "users/oauthApi",
  oauthServiceSalesforce
);
export const getResourceApi = createAsyncThunk(
  "users/getResourceApi",
  getResourceService
);
export const getResourceArticlesApi = createAsyncThunk(
  "users/getResourceArticlesApi",
  getResourceArticlesService
);
const initialState = {
    oauthApiData: {
        accessToken: "",
        refreshToken: "",
    },
    dropDwondValues:{
      state_dropDownValue: [],
      insurance_dropDownValue: [],
      ageRange_dropDownValue: [],
      Assistance_dropDownValue: [],
      medicalDiagnosis_dropDownValue: [],
    },
    getResourceData: {
    totalCount:'',
    loader:false,
    displayArticlesFlag:false,
    getResourceFilterData:{},
    getResourceArticlesData:[],
    updateFilterReducer:{}
  },
};
const financialResourceDirectorySlice = createSlice({
  name: "resourceDirectory", 
  initialState,
  reducers: {
    resetResourceDirectory:(state,action)=>{
         state.getResourceData= {
          loader:false,
          displayArticlesFlag:false,
          getResourceFilterData:{},
          getResourceArticlesData:[],
          updateFilterReducer:{}
        }
    },
    resetDropDownValue:(state,action)=>{
          state.dropDwondValues={
            state_dropDownValue: [],
            insurance_dropDownValue: [],
            ageRange_dropDownValue: [],
            Assistance_dropDownValue: [],
            medicalDiagnosis_dropDownValue: [],
          }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(oauthApi.pending, (state, action) => {
        // state.registerData.loader = true;
        // 
      })
      .addCase(oauthApi.fulfilled, (state, action) => {
      })
      .addCase(oauthApi.rejected, (state, action) => {
        toast.error(action.error.message);
      })
      .addCase(getResourceApi.pending, (state, action) => {
        state.getResourceData.loader=true;
      })
      .addCase(getResourceApi.fulfilled, (state, action) => {
        let res = action.payload.data
        let map = Object.keys(res.data).map((key) => {
            if (key == "StateorTerritory") {
              res.data[key].map((data) => {
                 state.dropDwondValues.state_dropDownValue.push({ key: data?.label, value: data?.value })
              });
            } else if (key == "NURDDxCategoryMain") {
              res.data[key].map((data) => {
                  state.dropDwondValues.medicalDiagnosis_dropDownValue.push({ key: data?.label, value: data?.value })
               });
            } else if (key == "InsuranceStatus") {
              res.data[key].map((data) => {
                  state.dropDwondValues.insurance_dropDownValue.push({ key: data?.label, value: data?.value })
               });
            } else if (key == "AssistanceMain") {
              res.data[key].map((data) => {
                  state.dropDwondValues.Assistance_dropDownValue.push({ key: data?.label, value: data?.value })
               });
            } else if (key == "AgeRange") {
              res.data[key].map((data) => {
                  state.dropDwondValues.ageRange_dropDownValue.push({ key: data?.label, value: data?.value })
               });  
            }
          });
          state.getResourceData.loader=false;
      })
      .addCase(getResourceApi.rejected, (state, action) => {
        toast.error(action.error.message);
        state.getResourceData.loader=false;
      })
      .addCase(getResourceArticlesApi.pending, (state, action) => {
          state.getResourceData.loader=true;

      })
      .addCase(getResourceArticlesApi.fulfilled, (state, action) => {
        state.getResourceData.loader=false;
        let countMsg = action.payload.data.message;
        let totalCount = ''; 
        
        for (let i = 0; i < countMsg.length; i++) {
            if (!isNaN(parseInt(countMsg[i]))) {
              totalCount += countMsg[i];
            } else {
                break;
            }
        }
        
       state.getResourceData.totalCount = parseInt(totalCount);
        
        if(action.payload.data.data.length >=1){
          state.getResourceData.displayArticlesFlag=true
        }
        let getResourceArr=[]
        let obj1=action.payload.data.data.map((item) => (getResourceArr.push({
            Title: !!item.Title ? item.Title:'',
            Website: !!item.Website? item.Website :'',
            OfficePhoneNumber: !!item.OfficePhoneNumber ? item.OfficePhoneNumber  :'',
            Description: !!item.Description ? item.Description :'',
            Summary: !!item.Summary ? item.Summary :'',
            Email: !!item.Email ? item.Email :'',
            StreetAddressLine1: !!item.StreetAddressLine1 ? item.StreetAddressLine1 :'',
            StreetAddressLine2: !!item.StreetAddressLine2 ? item.StreetAddressLine1 :'',
            States: !!item.States ? item.States :'' ,
            City: !!item.City ? item.City :'',
            ZipCode: !!item.ZipCode ? item.ZipCod :'',
            isChecked:false, // Toggle isChecked
              })));
        state.getResourceData.getResourceArticlesData=getResourceArr;
        let filter={}

          let obj=Object.keys(action.payload.data.dataCount).map((key)=>{
            filter[key] = action.payload.data.dataCount[key].map((item) => ({
                ...item,
                isChecked:false, // Toggle isChecked
              }));
            })
           
          state.getResourceData.getResourceFilterData=filter;

      })
      .addCase(getResourceArticlesApi.rejected, (state, action) => {
        state.getResourceData.loader=false;
        toast.error(action.error.message);
      });
  },
});
export const {resetResourceDirectory,resetDropDownValue} = financialResourceDirectorySlice.actions;
export default financialResourceDirectorySlice.reducer;
